// Main dashboard layout editor component that wires the split modules together.
import { dashboardLayoutEditorComputed, dashboardLayoutEditorData, dashboardLayoutEditorWatch } from "./layout-editor/dashboardLayoutEditorState";
import dashboardLayoutEditorTabs from "./layout-editor/dashboardLayoutEditorTabs";
import dashboardLayoutEditorCanvas from "./layout-editor/dashboardLayoutEditorCanvas";
import dashboardLayoutEditorBlocks from "./layout-editor/dashboardLayoutEditorBlocks";
import dashboardLayoutEditorPersistence from "./layout-editor/dashboardLayoutEditorPersistence";

Vue.asyncComponent('cms-dashboard-layout-editor', {
    data: dashboardLayoutEditorData,
    props: {
        viewMode: {
            type: String,
        },
        blueprintId: {
            type: [String, Number],
        },
        queryParams: {
            type: Object,
        },
        dataProviderClass: {
            type: Function,
        },
    },
    watch: dashboardLayoutEditorWatch,
    computed: dashboardLayoutEditorComputed,
    methods: {
        ...dashboardLayoutEditorTabs,
        ...dashboardLayoutEditorCanvas,
        ...dashboardLayoutEditorBlocks,
        ...dashboardLayoutEditorPersistence,
    },
    /**
     * Initialize this dashboard component after it is created.
     */
    async created() {
        this.dataProvider = new this.dataProviderClass(this.blueprintId, this.queryParams);
        await this.fetchData();

        this.activeBreakpointId = this.breakpoints[0]?.id || null;
        this.ensureActiveDashboardTab();
        this.blueprintDataStartState = JSON.parse(JSON.stringify(this.blueprintData));
        this.$confirmUnsavedChangesHandler.setShowConfirmCallback(this.checkShowConfirm);
        this.$confirmUnsavedChangesHandler.setConfirmMessage(this.$t('Ben je zeker dat je verder wilt gaan zonder te bewaren? De wijzigingen die je hebt gedaan, zullen verloren gaan.'));
    },
    /**
     * Clean up dashboard behavior before the component is destroyed.
     */
    beforeDestroy() {
        this.stopDashboardWidgetResize();
    },
}, 'cms/dashboard/editor/cms-dashboard-layout-editor.html');
